import { JsonConverter, JsonCustomConvert } from "json2typescript";

@JsonConverter
export class EventStatusConverter implements JsonCustomConvert<EventStatus>{
	serialize() { }
	deserialize(data: any): EventStatus {
		switch (data) {
			case 'LOGIN':
				{
					return EventStatus.LOGIN;
				}
			case 'LOGOUT':
				{
					return EventStatus.LOGOUT;
				}
			case 'INARPTABLE':
				{
					return EventStatus.INARPTABLE;
				}
			case 'NOTINARPTABLE':
				{
					return EventStatus.NOTINARPTABLE;
				}
			case 'INDHCP':
				{
					return EventStatus.INDHCP;
				}
			case 'NOTINDHCP':
				{
					return EventStatus.NOTINDHCP;
				}
			case 'TRAFFIC':
				{
					return EventStatus.TRAFFIC;
				}
			case 'NOTTRAFFIC':
				{
					return EventStatus.NOTTRAFFIC;
				}
			default:
				{
					return EventStatus.UNDEFINED;
				}
		}
	}
}

export enum EventStatus {
	LOGIN = 'LOGIN',
	LOGOUT = 'LOGOUT',
	INARPTABLE = 'INARPTABLE',
	NOTINARPTABLE = 'NOTINARPTABLE',
	INDHCP = 'INDHCP',
	NOTINDHCP = 'NOTINDHCP',
	TRAFFIC = 'TRAFFIC',
	NOTTRAFFIC = 'NOTTRAFFIC',
	UNDEFINED = 'UNDEFINED'
}
